module.exports = __webpack_public_path__ + "img/2.680b2294.svg";